/* eslint-disable import/prefer-default-export */
import { useContext, useEffect, useState } from 'react';
import { useField, useForm } from 'react-final-form';

import { ADD_BANK_DETAILS_ACTION_TYPE, maskFieldValue } from '../../AddBankDetails.helpers';
import { AddBankDetailsContext, AddBankDetailsContextType } from '../../AddBankDetailsContext';

type FieldFormatType = {
  defaultFormat?: string;
  maskedFormat: string;
  valueResolver?: (value: string) => string | undefined;
}

export const useMaskField = (
  name: string,
  { defaultFormat, maskedFormat, valueResolver }: FieldFormatType,
) => {
  const { action, index }: AddBankDetailsContextType = useContext(AddBankDetailsContext);

  const [masked, setMasked] = useState<boolean>();

  const { change, resetFieldState } = useForm();
  const { input: { value } } = useField(name);

  const shouldMaskInput = action === ADD_BANK_DETAILS_ACTION_TYPE.MASK;

  const onInputFocus = () => {
    if (masked) {
      change(name, '');
      resetFieldState(name);

      setMasked(false);
    }
  };

  useEffect(() => {
    if (shouldMaskInput) {
      change(name, maskFieldValue({ mask: maskedFormat, value, valueResolver }));
      resetFieldState(name);

      setMasked(true);
    }
  }, [index, shouldMaskInput]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    format: masked ? maskedFormat : defaultFormat,
    masked,
    onInputFocus,
  };
};
